import React, { Fragment, useEffect, useState } from 'react'
import { Tag } from 'antd'
import { BBDTag, Horizontal, Texto } from '@gravitate-js/excalibrr'
import { LinkOutlined } from '@ant-design/icons'

export const TankManifoldDisplay = ({ tank }) => {
  const [tankManifold, setTankManifold] = useState()

  useEffect(() => {
    if (!tank.manifolds) return
    const tankManifoldMatch = tank.manifolds.find((mani) => mani.manifold_id === tank.manifold_id)
    setTankManifold(tankManifoldMatch)
  }, [tank])

  if (!tankManifold) {
    return (
      <Texto category='h4' className='pt-1' appearance='hint'>
        No Manifold Set
      </Texto>
    )
  }
  return (
    <Horizontal className='mt-1' verticalCenter>
      <BBDTag className='px-3' theme2>
        <LinkOutlined className='pr-2' /> {tankManifold.manifold_id}
      </BBDTag>
      {tankManifold.tanks.map((tankId, i) => (
        <Fragment key={i}>
          <Texto category='h6' className='px-3' weight='bold'>
            :
          </Texto>
          <BBDTag style={{ minWidth: 'fit-content' }}>#{tankId}</BBDTag>
        </Fragment>
      ))}
    </Horizontal>
  )
}
